import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import MyAccount from './pages/MyAccount';
import SearchPartner from './pages/SearchPartner';
import UserProfile from './pages/UserProfile';
import Help from './pages/Help';
import Classifieds from './pages/Classifieds';
import ChatPage from './pages/Chat';
import Reports from './pages/Reports';
import AdminUserConversations from './pages/AdminUserConversations';
import AdminConversationMessages from './pages/AdminConversationMessages';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ResetPassword from './pages/ResetPassword';
import MessageNotification from './components/MessageNotification';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/mi-cuenta" element={<MyAccount />} />
              <Route path="/buscar-pareja" element={<SearchPartner />} />
              <Route path="/perfil/:id" element={<UserProfile />} />
              <Route path="/mensajes" element={<ChatPage />} />
              <Route path="/reportes" element={<Reports />} />
              <Route path="/admin/conversaciones/:userId" element={<AdminUserConversations />} />
              <Route path="/admin/mensajes/:userId/:otherUserId" element={<AdminConversationMessages />} />
              <Route path="/ayuda" element={<Help />} />
              <Route path="/clasificados" element={<Classifieds />} />
              <Route path="/terminos-de-uso" element={<TermsOfUse />} />
              <Route path="/privacidad" element={<PrivacyPolicy />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </Routes>
          </main>
          <Footer />
          <MessageNotification />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
